<template>
    <div class="kfc_detail_wrap">
        <div class="content">
            <div class="basic_info">
                <img :src="imgBaseUrl + comboInfo.logo" alt />
                <p>{{comboInfo.description}}</p>
            </div>
            <div class="product_num fr ac jsb">
                <div class="fc">
                    <p class="price">
                        ￥
                        <strong>{{comboInfo.price}}</strong>
                        <!-- <span>￥{{comboInfo.martetprice}}</span> -->
                    </p>
                    <!-- <span class="saved" v-if="comboInfo.martetprice && comboInfo.price && comboInfo.martetprice - comboInfo.price > 0">已省{{(comboInfo.martetprice - comboInfo.price).toFixed(1)}}元</span> -->
                </div>
                <div v-if="comboInfo.qty && comboInfo.qty > 0" class="num_box fr ac jsb">
                    <img @click="removeItem" src="../../../static/imgs/kfc/minus.png" alt />
                    <span>{{comboInfo.qty}}</span>
                    <img @click="addItem" src="../../../static/imgs/kfc/plus.png" alt />
                </div>
                <img
                    @click="addItem"
                    v-else
                    class="num_icon"
                    src="../../../static/imgs/kfc/plus.png"
                    alt
                />
            </div>
            <div v-show="comboInfo.singleItemList.length" class="item_list fc">
                <h3>餐品列表</h3>
                <div
                    class="item_info fr ac jsb"
                    v-for="(item, index) in comboInfo.singleItemList"
                    :key="index"
                >
                    <img :src="imgBaseUrl + item.productLogo" alt />
                    <h4>{{item.productName}}</h4>
                    <span>×{{item.qty}}</span>
                </div>
            </div>
        </div>
        <div class="footer fr ac jsb">
            <div class="fr ac">
                <div class="icon_wrap">
                    <img class="cart_icon" src="../../../static/imgs/kfc/kfc-cart.png" alt />
                    <span v-show="cartQty">{{cartQty}}</span>
                </div>
                <span class="total">￥{{cartTotal}}</span>
            </div>
            <button @click="confirm" class="btn">选好了</button>
        </div>
    </div>
</template>

<script>
import { Toast } from "mint-ui";
export default {
    data() {
        return {
            imgBaseUrl: this.$global.imgBaseUrl,
            comboInfo: [],
            cartArr: this.getLocal("cartArr") ? this.getLocal("cartArr") : [],
            cartQty: this.$route.query.cartQty,
            cartTotal: this.$route.query.cartTotal
        };
    },
    components: {},
    created() {
        this.comboInfo = JSON.parse(decodeURIComponent(this.$route.query.info));
    },
    methods: {
        addItem() {
            let cartArr = this.cartArr,
                comboInfo = this.comboInfo;
            if (cartArr.length) {
                let idArr = [];
                for (let i of cartArr) {
                    idArr.push(i.id);
                }
                if (idArr.indexOf(comboInfo.id) < 0) {
                    comboInfo.qty = 1;
                    comboInfo.isExtend = false;
                    cartArr.push(comboInfo);
                } else {
                    console.log(comboInfo.qty, cartArr);
                    let idx = idArr.indexOf(comboInfo.id);
                    cartArr[idx].qty += 1;
                    comboInfo.qty = cartArr[idx].qty;
                }
            } else {
                comboInfo.qty = 1;
                comboInfo.isExtend = false;
                cartArr.push(comboInfo);
            }
            this.setLocal("cartArr", cartArr);
            this.cartArr = cartArr;
            this.comboInfo = comboInfo;
            this.calcCartTotal();
            Toast({
                message: "加入成功",
                position: "middle",
                duration: 2000,
                className: "toastBox"
            });
        },
        removeItem() {
            let cartArr = this.cartArr,
                comboInfo = this.comboInfo;
            for (let i in cartArr) {
                if (cartArr[i].id == comboInfo.id) {
                    if (cartArr[i].qty > 1) {
                        cartArr[i].qty = cartArr[i].qty - 1;
                        comboInfo.qty = cartArr[i].qty;
                    } else {
                        cartArr.splice(i, 1);
                        comboInfo.qty = 0;
                    }
                }
            }
            this.setLocal("cartArr", cartArr);
            this.cartArr = cartArr;
            this.comboInfo = comboInfo;
            this.calcCartTotal();
        },
        confirm(){
            this.$router.go(-1);
        },
        // 计算购物车内商品总价
        calcCartTotal() {
            let cartArr = this.cartArr,
                cartTotal = 0,
                cartQty = 0;
            for (let i of cartArr) {
                cartQty += i.qty;
                let actualPrice = 0;
                if (i.choice && i.actualPrice) {
                    cartTotal += i.actualPrice;
                } else if (i.choice) {
                    actualPrice += i.price;
                    for (let j of i.mutiArr[1]) {
                        if (j.isSelected) {
                            actualPrice += j.addprice;
                        }
                    }
                    i.actualPrice = actualPrice;
                    cartTotal += actualPrice;
                } else {
                    i.actualPrice = i.price;
                    cartTotal += i.price * i.qty;
                }
            }
            this.cartTotal = cartTotal.toFixed(1);
            this.cartQty = cartQty;
            this.cartArr = cartArr;
            this.setLocal("cartArr", cartArr);
        }
    }
};
</script>
<style lang="scss">
.kfc_detail_wrap {
    .content {
        padding-bottom: 120px;
        .basic_info {
            background: #fff;
            margin-bottom: 20px;
            img {
                width: 100%;
                height: 500px;
            }
            p {
                width: 100%;
                padding: 18px 30px;
                box-sizing: border-box;
                font-size: 28px;
                color: #999;
                line-height: 38px;
            }
        }
        .product_num {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            background: #fff;
            height: 120px;
            margin-bottom: 20px;
            .price {
                font-size: 24rpx;
                color: #d62f35;
                strong {
                    font-size: 36px;
                }
                span {
                    color: #999;
                    margin-left: 10px;
                }
            }
            .saved {
                color: #fc9030;
                font-size: 20rpx;
                margin-right: 18px;
            }
            .num_icon {
                width: 50px;
                height: 50px;
            }
            .num_box {
                img {
                    width: 50px;
                    height: 50px;
                }
                span {
                    font-size: 28px;
                    width: 50px;
                    text-align: center;
                }
            }
        }
        .item_list {
            background: #fff;
            h3 {
                width: 100%;
                padding: 0 30px;
                box-sizing: border-box;
                font-size: 28px;
                height: 80px;
                line-height: 80px;
            }
            .item_info {
                width: 100%;
                padding: 10px 30px;
                box-sizing: border-box;
                font-size: 28px;
                img {
                    width: 120px;
                    height: 80px;
                    background: pink;
                    margin-right: 20px;
                }
                h4 {
                    width: 460px;
                    font-weight: bold;
                    text-align: left;
                }
            }
        }
    }
    .footer {
        width: 100%;
        height: 120px;
        background: #fff;
        position: fixed;
        bottom: 0;
        .icon_wrap {
            width: 80px;
            height: 80px;
            margin-left: 40px;
            position: relative;
            .cart_icon {
                width: 80px;
                height: 80px;
            }
            span {
                background: #d62f35;
                color: #fff;
                position: absolute;
                font-size: 22px;
                top: -5px;
                right: -8px;
                height: 32px;
                line-height: 32px;
                min-width: 22px;
                border-radius: 16px;
                text-align: center;
                padding: 0 10px;
            }
        }
        .total {
            color: #d62f35;
            margin-left: 30px;
            font-size: 32px;
        }
        .btn {
            width: 250px;
            text-align: center;
            background: #d62f35;
            font-size: 32px;
            color: #fff;
            border-radius: 0;
            height: 120px;
            line-height: 120px;
            padding: 0 40px;
            border-left: 1px solid #fff;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/kfc/kfcProductDetail.vue